/**
 * Navigation scripts
 */
document.addEventListener("DOMContentLoaded", () => {
    const $ = jQuery;

    function navigationResponsiveFunctions() {
        if (window.matchMedia("screen and (min-width: 1201px)").matches) {
            $('.site-header').removeClass('menu-opened');
            $('.mega-menu, .mobile-navigation, .mega-menu-submenu').removeClass('opened');
            $('.mobile-navigation .mega-menu-submenu').find('.icon-arrow-down').toggleClass('rotate-180')
            $('.mobile-navigation .submenu-items').slideUp(200);
            $('.menu-close-button, .menu-back-button, .mobile-navigation .submenu-items').addClass('hidden');
            $('.menu-open-button').removeClass('hidden');

            const scrollPos = parseInt($('html').css('marginTop').replace('px', '')) * -1;

            $('html').css('marginTop', '');
            $('body').css({'width': '', height: ''}).removeClass('mobile-menu-opened');

            window.scrollTo(0, scrollPos);
        }

        if (window.matchMedia("screen and (max-width: 1200px)").matches) {
            // Open/close mega-menu
            $('.mega-menu-nav-item > a').on('click', function (e) {
                e.preventDefault();

                const $this = $(this);

                $this.parent().find('.mega-menu').addClass('opened');

                $('.menu-close-button').addClass('hidden');
                $('.menu-back-button').removeClass('hidden');
            });

            // Open/close mega-menu submenu
            $('.submenu-title').off().on('click', function () {
                $(this).siblings('.submenu-items').slideToggle(200);
                $(this).siblings('.submenu-items').toggleClass('hidden');
                $(this).find('.icon-arrow-down').toggleClass('rotate-180');
                $(this).parent().toggleClass('opened');
            });
        }
    }

    window.addEventListener('resize', navigationResponsiveFunctions);
    navigationResponsiveFunctions();

    $('.menu-open-button').on('click', function () {
        $(this).addClass('hidden');
        $('.menu-close-button').removeClass('hidden');
        $('.mobile-navigation').addClass('opened');

        $('.site-header').addClass('menu-opened');

        $('html').css('marginTop', window.scrollY * (-1));
        $('body').addClass('mobile-menu-opened');
    });

    $('.menu-close-button').on('click', function () {
        $(this).addClass('hidden');
        $('.menu-open-button').removeClass('hidden');
        $('.mobile-navigation').removeClass('opened');

        $('.site-header').removeClass('menu-opened');

        const scrollPos = parseInt($('html').css('marginTop').replace('px', '')) * -1;
        $('html').css('marginTop', '');
        $('body').css({'width': '', height: ''}).removeClass('mobile-menu-opened');
        window.scrollTo(0, scrollPos);
    });

    $('.menu-back-button').on('click', function () {
        $(this).addClass('hidden');
        $('.menu-close-button').removeClass('hidden');
        $('.mega-menu').removeClass('opened');

        $('.mega-menu-submenu').each(function () {
            $(this).removeClass('opened');
            $(this).children().last().slideUp(200);
            $(this).children().last().addClass('hidden');
            $(this).find('.icon-arrow-down').removeClass('rotate-180');
        });
    });
});